import { RecommendedAssignments } from 'components/RecommendedAssignments';
import { useRecordContext } from 'ra-core';
import React from 'react';

export const RecommendedAssignmentsTab = () => {
  const assignmentRequest = useRecordContext();
  const { assignment_id, professional_id } = assignmentRequest;
  return <RecommendedAssignments assignment_id={assignment_id} professional_id={professional_id} />;
};
